import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getFileLink,
  getFileLinkRequest,
  uploadFile,
  UploadFileRequest,
  UploadFileResponse,
} from "./file.api";
import { UploadFileErrorMessages } from "./file.error";
import { on } from "events";

export const uploadFileThunk = createAsyncThunk(
  "File/UploadFile",
  async (request: UploadFileRequest, { rejectWithValue }) => {
    const { response, error } = await uploadFile(request);
    if (error) {
      toast.info(UploadFileErrorMessages[error]);
      return rejectWithValue(error);
    }
    return response;
  }
);

export const getFileLinkThunk = createAsyncThunk(
  "File/GetFileLink",
  async (request: getFileLinkRequest, { rejectWithValue }) => {
    const { response, error } = await getFileLink(request);
    if (error) {
      rejectWithValue(error);
    }

    return response;
  }
);
